/*
 * @Description: 
 * @Author: duanwensheng
 * @Date: 2022-03-29 10:12:33
 */
import React, { useState } from 'react'
import { Redirect, Route, Switch, withRouter, useParams } from "react-router-dom";

import usePageLogin from "tools/utils/hooks/usePageLogin";

import globalStoreContext from '../globalStore'
import routers from './Router'
// import { isWechat } from 'tools/utils';
import { weChatFn, isWechat } from '@sqb/utility';

import { reportPoint } from 'wmda_bx_report';
import useVisitReport from "tools/utils/hooks/useVisitReport";


// 如果后期需要添加一下公用的方法，
const CommonPage = props => {
    //增加页面浏览埋点
    reportPoint(Object.assign({}, props.point, useParams()));

    // 判断页面是否需要进行登录
    usePageLogin();


    // 页面访问上报
    useVisitReport();

    const C = props.component;

    return <C {...props} />;
}

class MainRouter extends React.Component {
    componentDidMount() {
        isWechat() && weChatFn.init();
    }

    render() {
        return (
            <Switch>
                {
                    routers.map((item, index) => {
                        return (
                            <Route key={index} path={item.path} render={props => (
                                <CommonPage point={item.point} component={item.component} {...props} />
                            )} />
                        )
                    })
                }

                <Redirect to='/notFound' />
            </Switch>
        );
    }
}

// @ts-ignore
let MainRouterC = withRouter(MainRouter);

export default () => {
    const [global, setGlobal] = useState({});

    return (
        <globalStoreContext.Provider value={{ global, setGlobal }}>
            <MainRouterC />
        </globalStoreContext.Provider>
    )
}

